// extracted by mini-css-extract-plugin
module.exports = {"links":"Layout_links__258MS","qrWrapper":"Layout_qrWrapper__2GxPl","secretLabel":"Layout_secretLabel__NBkib","secretCode":"Layout_secretCode__1rxWS"};